import parse from "html-react-parser";
import DOMPurify from "dompurify";
export const getStorageData = (key) => {
  try {
    return JSON.parse(window.localStorage.getItem(key)) || {};
  } catch (err) {
    return {};
  }
};

export const setStorageData = (key, data) => {
  const dataTemp = JSON.stringify(data);
  window.localStorage.setItem(key, dataTemp);
};

export const htmlParser = (htmlString) => {
  const cleanHtml = DOMPurify.sanitize(htmlString, {
    FORBID_TAGS: ["script"],
    FORBID_ATTR: ["onerror", "onclick", "onload"], // etc.
  });
  return parse(cleanHtml);
};

export const formatUrl = (url) => {
  if (!url.startsWith("http://") && !url.startsWith("https://")) {
    return "https://" + url;
  }
  return url;
};

export const combineDateAndTime = (
  date,
  time,
  timeZone,
  timeFormate,
  combine = true
) => {
  if (!date && !time) {
    return "";
  }
  let newDate;
  const combineDate = combine ? date + " " + time : date;

  if (timeZone) {
    newDate = changeTimeZone(combineDate, timeZone);
  } else {
    newDate = new Date(combineDate.trim());
  }
  const year = newDate.getFullYear();
  const currentDate = newDate.getDate();
  const hours = String(newDate.getHours()).padStart(2, "0");
  const minutes = String(newDate.getMinutes()).padStart(2, "0");
  const seconds = String(newDate.getSeconds()).padStart(2, "0");
  let currentMonth = newDate.getMonth() + 1;

  const day = currentDate < 10 ? `0${currentDate}` : currentDate;
  let month = currentMonth < 10 ? `0${currentMonth}` : currentMonth;
  let days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const dayName = days[newDate.getDay()];

  switch (timeFormate) {
    case "YYYY-M-D H:m":
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    case "D-M-YYYY H:m":
      return `${day}-${month}-${year} ${hours}:${minutes}`;
    case "YYYY-M-D H:m:s":
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    case "H:m":
      return `${hours}:${minutes}`;
    case "ddd D M Y":
      currentMonth = newDate.toLocaleString("default", { month: "short" });
      month = currentMonth < 10 ? `0${currentMonth}` : currentMonth;
      return `${dayName.slice(0, 3)} ${day} ${month} ${year}`;
    case "ddd":
      return `${dayName.slice(0, 3)}`;
    case "YYYY-M-D":
      return `${year}-${month}-${day}`;
    case "D M Y H:m":
      currentMonth = newDate.toLocaleString("default", { month: "short" });
      month = currentMonth < 10 ? `0${currentMonth}` : currentMonth;
      return `${day} ${month} ${year} ${hours}:${minutes}`;
    case "D M Y, H:m":
      currentMonth = newDate.toLocaleString("default", { month: "short" });
      month = currentMonth < 10 ? `0${currentMonth}` : currentMonth;
      return `${day} ${month} ${year}, ${hours}:${minutes}`;
    case "D M Y":
      currentMonth = newDate.toLocaleString("default", { month: "short" });
      month = currentMonth < 10 ? `0${currentMonth}` : currentMonth;
      return `${day} ${month} ${year}`;
    case "D M":
      currentMonth = newDate.toLocaleString("default", { month: "short" });
      month = currentMonth < 10 ? `0${currentMonth}` : currentMonth;
      return `${day} ${month}`;
    case "ddd D, Y, H:m":
      currentMonth = newDate.toLocaleString("default", { month: "short" });
      month = currentMonth < 10 ? `0${currentMonth}` : currentMonth;
      return `${dayName.slice(0, 3)} ${day}, ${year}, ${hours}:${minutes}`;
    default:
      return `${day} ${month} ${year} ${hours}:${minutes}`;
  }
};

const changeTimeZone = (newDate, timeZone) => {
  if (timeZone === "UTC") {
    newDate = new Date(newDate);
    return new Date(newDate.toLocaleString("en-US", { timeZone: "UTC" }));
  } else if (timeZone === "current") {
    if (newDate && !newDate.includes(".000000Z")) {
      newDate = combineDateAndTime(newDate, "", "", "YYYY-M-D H:m:s");
      newDate = new Date(newDate.trim() + ".000000Z");
    }

    return new Date(
      newDate.toLocaleString("en-US", {
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      })
    );
  }
};
